<template>
  <CustomPage :noTitle="true" :noBorder="true">
    <div slot="content">
      <div class="searchresult bg-white">
        <NavBar left-arrow>
          <template #left>
            <Icon
              name="arrow-left"
              color="black"
              size="24"
              @click="$router.back()"
            />
          </template>
          <template #title>
            <Search
              v-model="text"
              shape="round"
              placeholder="搜索"
              @click="$router.back()"
            >
              <template #left-icon>
                <Icon name="search" color="red" />
              </template>
            </Search>
          </template>
          <template #right>
            <img src="@/assets/search/yun.svg" alt="" />
          </template>
        </NavBar>
        <!-- <Tabs v-model="activeType" class="border-b border-red-600 pb-3">
      <Tab title="商品"></Tab>
      <Tab title="活动"></Tab>
    </Tabs> -->

        <div v-if="activeType === 0">
          <div
            v-for="item in actBrands"
            :key="item.partId"
            class="rounded-lg lightshadow p-2 m-3"
            @click="
              $router.push({
                name: 'BrandPlace',
                params: { partId: item.partId },
                query: {
                  actId: item.actId,
                  brandLogo: item.brandLogo,
                  signBrandId: item.signBrandId,
                },
              })
            "
          >
            <div class="flex items-center py-3">
              <div style="height: 44px; width: 44px" class="flex-shrink-0">
                <img
                  class="h-full w-full rounded-lg"
                  :src="item.brandLogo"
                  alt=""
                />
              </div>
              <div class="flex-grow mx-2" style="width: 55%">
                <div
                  class="text-left font-semibold overflow-x-scroll"
                  style="white-space: nowrap"
                >
                  <span class="text-base"> {{ item.brandName }} </span
                  ><span class="text-xs" style="white-space: nowrap">{{
                    item.actName
                  }}</span>
                </div>
                <div class="flex flex-row flex-no-wrap overflow-x-scroll h-5">
                  <span
                    class="text-xxs text-red border-red1px rounded px-1 mr-1"
                    style="white-space: nowrap; line-height: 1.125rem"
                    >共{{ item.actGoodsList.length }}款</span
                  >
                  <span
                    v-for="i in item.partServices"
                    :key="i.id"
                    class="text-xxs text-red border-red1px rounded px-1 mr-1"
                    style="white-space: nowrap; line-height: 1.125rem"
                    >{{ i.name }}</span
                  >
                </div>
              </div>
              <div
                class="
                  text-white
                  rounded-full
                  flex flex-row
                  items-center
                  pr-1
                  pl-2
                  justify-end
                  flex-shrink-0
                "
                style="
                  background-color: #e82035;
                  padding-top: 0.1rem;
                  padding-bottom: 0.1rem;
                "
              >
                <span class="text-xs">进入会场</span
                ><Icon name="arrow" class="ml-1" />
              </div>
            </div>
            <div class="flex justify-start">
              <template v-for="(i, index) in item.actGoodsList">
                <div
                  v-if="index < 5"
                  :key="i.goodsId"
                  class="act-goods-list-item relative mr-2"
                >
                  <img
                    :src="i.goodsImage"
                    class="absolute h-full w-full rounded-full top-0 left-0"
                    style="object-fit: cover"
                  />
                </div>
              </template>
              <div
                class="act-goods-list-item relative rounded-full"
                style="background-color: #f5f5f5"
              >
                <div class="absolute text-xxs font-light" style="top: 35%">
                  查看更多...
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="flex flex-row flex-no-wrap mx-3 my-3 text-xs">
            <span class="text-gray mr-3">排序</span>
            <div class="flex flex-grow justify-start">
              <div
                v-for="item in [
                  { key: '上新', value: 'upNew' },
                  { key: '销量', value: 'salesNum' },
                  { key: '转发次数', value: 'forwardNum' },
                ]"
                :key="item.value"
                style="
                  display: inline-block;
                  box-sizing: border-box;
                  width: 20%;
                "
                :class="{ activeSort: activeSort === item.value }"
                @click="changeSort(item.value)"
              >
                {{ item.key }}
              </div>
            </div>
            <!-- <div @click="showShaixuan = true">筛选</div> -->
          </div>
          <!-- <Popup
        v-model="showShaixuan"
        position="right"
        class="h-full px-3 pt-8 pb-3"
        style="max-width: 70%"
        ><div class="h-full flex flex-col justify-between">
          <div>
            <div class="text-left">价格区间（元）</div>
            <div class="flex jiagequjian">
              <Field
                v-model="searchForm.from"
                type="number"
                class="mr-2"
                style="background-color: #f6f6f6"
              />
              —
              <Field
                v-model="searchForm.to"
                type="number"
                class="ml-2"
                style="background-color: #f6f6f6"
              />
            </div>
            <div class="text-left">品牌</div>
            <div class="flex flex-wrap justify-between">
              <div
                v-for="item in brandList"
                :key="item"
                class="box-border w-1/4 flex justify-center"
              >
                <div
                  class="rounded font-light my-1 py-1"
                  :class="{ active: searchForm.brand === item }"
                  style="width: 6rem; background-color: #f6f6f6"
                  @click="$set(searchForm, 'brand', item)"
                >
                  {{ item }}
                </div>
              </div>
            </div>

            <div class="text-left">促销活动</div>
            <div class="flex flex-wrap justify-between">
              <div
                v-for="item in cuxiaoList"
                :key="item"
                class="box-border w-1/4 flex justify-center"
              >
                <div
                  class="rounded font-light my-1 py-1"
                  :class="{ active: searchForm.cuxiao === item }"
                  style="width: 6rem; background-color: #f6f6f6"
                  @click="$set(searchForm, 'cuxiao', item)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <Button
              round
              type="danger"
              plain
              size="small"
              class="flex-grow"
              style="margin-right: 0.3rem"
              @click="searchForm = {}"
              >重置</Button
            >

            <Button
              round
              type="danger"
              size="small"
              class="flex-grow"
              style="margin-left: 0.3rem"
              @click="search"
              >确认</Button
            >
          </div>
        </div></Popup
      > -->
          <GoodsList v-if="activeType === 0" :sortby="activeSort" />
          <!-- <ActivityList v-if="activeType === 1" /> -->
        </div>
        <CustomView />
      </div>
    </div>
  </CustomPage>
</template>

<script>
import { NavBar, Search, Icon, Tab, Tabs, Popup, Field, Button } from "vant";
import CustomView from "@/components/custom-view.vue";
import CustomPage from "@/components/custom-page.vue";
import GoodsList from "./components/GoodsList";
import ActivityList from "./components/ActivityList";
import { getActBrands } from "./webApi";
export default {
  components: {
    CustomView,
    CustomPage,
    NavBar,
    Search,
    Icon,
    // Tab,
    // Tabs,
    // Popup,
    // Field,
    // Button,
    GoodsList,
    // ActivityList,
  },
  created() {
    this.text = this.$route.params.text;
    getActBrands(this.$route.params.text).then(({ data }) => {
      this.actBrands = data
    });
  },
  data() {
    return {
      text: "",
      actBrands: [],
      activeType: 0,

      activeSort: "upNew",
      showShaixuan: false,
      searchForm: {},
      brandList: ["a", "b", "c"],
      cuxiaoList: ["1", "2", "3"],
    };
  },
  methods: {
    changeSort(item) {
      this.activeSort = item;
    },
    search() {
      this.showShaixuan = false;
    },
  },
};
</script>

<style scoped>
.activeSort {
  color: #e82035;
  font-weight: 600;
}
.active {
  background-color: #d8283b !important;
  color: #fff;
}
.jiagequjian .van-field {
  padding-top: 6px;
  padding-bottom: 6px;
}
.act-goods-list-item {
  width: 100px;
  height: 100px;
}
</style>